var map = {
	selectors: {
		mapView: '.content--active .map__map',
    },
    icons: {
        info: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="m32 0a24.0319 24.0319 0 0 0 -24 24c0 17.23 22.36 38.81 23.31 39.72a.99.99 0 0 0 1.38 0c.95-.91 23.31-22.49 23.31-39.72a24.0319 24.0319 0 0 0 -24-24zm0 35a11 11 0 1 1 11-11 11.0066 11.0066 0 0 1 -11 11z"></path></svg>'
    },

	init: function () {
		var self = this;

		if (document.querySelector(self.selectors.mapView)) {
            self.initiateMap();
		}
    },

    initiateMap: function () {
        var self = this;

        var $map = document.querySelector(self.selectors.mapView);
        // console.log( mapboxData );

        if (mapboxData['map'] && $map) {
            var mapData = mapboxData['map'];

            mapboxgl.accessToken = mapboxData.accessToken;
            var map = new mapboxgl.Map({
                container: $map,
                style: mapData.style,
                center: [mapData.center_lng, mapData.center_lat],
                zoom: mapData.zoom,
            });

            map.scrollZoom.disable();

            map.addControl(new mapboxgl.NavigationControl(), 'top-left');
            map.addControl(new mapboxgl.GeolocateControl({
                positionOptions: {
                    enableHighAccuracy: true
                },
                trackUserLocation: true
            }));

            if (mapData['markers']) {
                //var $markerLegends = $map.parent().find('[data-map-marker]');
                var markers = mapData['markers'];
                // var markerObjects = [];

                var i = 0;
                var bounds = new mapboxgl.LngLatBounds();

                for (var marker in markers) {
                    // console.log( markers[marker] );

                    var markerData = markers[marker],
                    markerEl = document.createElement('a');
                    markerEl.className = 'map-marker map-marker--' + markerData.legend;
                    markerEl.setAttribute('data-map-target', i);
                   //  markerEl.setAttribute('postid', markerData.post_id );
                    markerEl.setAttribute('data-modal-trigger', 'marker' );
                    markerEl.setAttribute('data-map-coordinates', JSON.stringify([markerData.lng, markerData.lat]));

                    if (i === 0) {
                        // markerEl.className = 'map__marker active';
                    }

                    markerEl.innerHTML = '<i class="mapbox-icon">'+ self.icons.info +'</i>';

                    var markerObject = new mapboxgl.Marker(markerEl).setLngLat([markerData.lng, markerData.lat]).addTo(map);

                    bounds.extend([markerData.lng, markerData.lat]);

                    i++;
                }


                jQuery('.map-marker').on('click', function (e) {
                    // e.stopPropagation();

                    var $marker = jQuery(this);

                    $marker.addClass('active');
                    var post_id = $marker.attr( 'postid' );
                    var coordinates = JSON.parse( $marker.attr('data-map-coordinates') );


                    var nthMarker = jQuery(this).data("map-target");

                    // console.log(nthMarker);

                    jQuery( ".modal__inner--marker" ).html( map_popup_text[nthMarker]["content"] );
                    jQuery( ".modal__inner--ytb" ).html(" ");

                    map.flyTo({
                        center: coordinates,
                    });
                });

                /* $markerLegends.on('click', function (e) {
                    var target = jQuery(this).attr('data-map-marker');
                    var $marker = markers.filter('[data-map-target="' + target + '"]');

                    $marker.trigger('click');
                }); */

                //map.fitBounds(bounds, { padding: 100 });
            }
        }
    },
    getMarkerInfo: function( post_id ) {
        var data = {
            'action': 'load_marker_info',
            'post_id': post_id,
        };
 
        jQuery.post(themeVars.ajax_url, data, function(response) {
            jQuery('.modal__inner--marker').html( response );
        });
    },
};

export { map };
